import React from "react";
import { ChildType } from "@common/types/tree-types";
import styles from "../../TreeComponents.module.scss";
import { OurNode } from "@src/cloud-connect/poc/our-node";
import { FilteredNodeOurNode } from "../filtered-node-our-node";
import { useFilterViewOurNodeInitialHook } from "./use-filter-view-our-node-initial-hook";

export interface FilterViewOurNodeObj {
  data: OurNode[];
}

type FilterViewProps = {
  updateCheckboxFunc: (node: ChildType) => void;
  type: "initial" | "machine";
  activateDragAndDrop: boolean;
  useHook: () => FilterViewOurNodeObj;
};

export const FilterViewOurNode = ({
  updateCheckboxFunc,
  type,
  activateDragAndDrop,
  useHook = useFilterViewOurNodeInitialHook,
}: FilterViewProps) => {
  const { data } = useHook();

  return (
    <>
      <ul className={styles["filter-list"]}>
        {data &&
          data.map((item) => (
            <FilteredNodeOurNode
              child={item}
              updateCheckboxFunc={updateCheckboxFunc}
              type={type}
              key={item.key}
              activateDragAndDrop={activateDragAndDrop}
            />
          ))}
      </ul>
    </>
  );
};
